import React, { useState, useRef, useEffect } from 'react';
import ActionButtons from './ActionButtons';
import { useTranslation } from 'react-i18next';
import { GENERAL_ERROR_UPDATE_PAGE_MESSAGE } from '../../../../../i18n/keyConstants';
/**
 * OnClick opens a dropdown where the value can be edited.
 */
const GenericEditable = ({ children, handleSave, handleCancel, customDisplayWrapper, description, valueHasntChanged }) => {
    const [DisplayComponent, EditComponent] = children;

    const [isOpen, setIsOpen] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [shouldCancel, setShouldCancel] = useState(false);
    const ref = useRef();
    const { t } = useTranslation(['errorMessages']);


    useEffect(() => {
        const handleDocumentClick = (event) => {
            if (ref.current && !ref.current.contains(event.target) && !isSaving) {
                setShouldCancel(true);
            }
        };

        document.addEventListener('mousedown', handleDocumentClick);
        return () => {
            document.removeEventListener('mousedown', handleDocumentClick);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (shouldCancel) {
            if (!isSaving) {
                setIsOpen(false);
                handleCancel();
                setErrorMessage('');
            }
            setShouldCancel(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldCancel]);

    const onSave = async () => {
        if (isSaving) return;
        setIsSaving(true);
        if (valueHasntChanged()) {
            await new Promise((r) => setTimeout(r, 500));
            setIsOpen(false);
            setIsSaving(false);
            setErrorMessage('');
            return { success: true };
        }
        const response = await handleSave();
        setIsSaving(false);
        if (response.success) {
            setIsOpen(false);
            setErrorMessage('');
        } else {
            setErrorMessage(response.message && response.message.length ? response.message : t(GENERAL_ERROR_UPDATE_PAGE_MESSAGE));
        }
    };

    const onKeyDown = (event) => {
        // Enter selects active index and creates tag
        if (event.keyCode === 13) {
            onSave();
            event.preventDefault();
        }

        // Escape cancels
        else if (event.keyCode === 27) {
            setShouldCancel(true);
            event.preventDefault();
        }
    };

    return (
        <div ref={ref} className={`editable crm-editable-field-wrapper`}>
            <div className={`editable-display-component`} onClick={() => setIsOpen(!isOpen)}>
                {customDisplayWrapper ? customDisplayWrapper(DisplayComponent) : DisplayComponent}
            </div>
            {isOpen && (
                <div className={`editable-dropdown `}>
                    <div className='dd-content'>
                        {description && <div className='description'>{description}</div>}
                        <div className='field-input-group'>
                            {React.cloneElement(EditComponent, {
                                onSave,
                                onKeyDown,
                                isInvalid: errorMessage !== '',
                                isSaving,
                                autoFocus: true,
                            })}
                        </div>
                        {errorMessage && <div className='crm-invalid-msg'>{errorMessage}</div>}
                    </div>
                    <ActionButtons {...{ onSave, isSaving }} onCancel={() => setShouldCancel(true)} />
                </div>
            )}
        </div>
    );
};

export default GenericEditable;
